import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

const StudentContext = createContext(null);

export const StudentProvider = ({ children }) => {
  const [xp, setXp] = useState(1240);
  const [challengeDone, setChallengeDone] = useState(false);
  const [saved, setSaved] = useState({});
  const [liked, setLiked] = useState({});
  const [chips, setChips] = useState({ learn: 'All', jobs: 'All', clubs: 'My Clubs' });
  const [theme, setTheme] = useState('light');
  const [toast, setToast] = useState('');
  const [sheetOpen, setSheetOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const toastTimer = useRef(null);

  const showToast = useCallback((message) => {
    setToast(message);
    window.clearTimeout(toastTimer.current);
    toastTimer.current = window.setTimeout(() => setToast(''), 1800);
  }, []);

  const openMenu = useCallback(() => setMenuOpen(true), []);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const openSheet = useCallback(() => setSheetOpen(true), []);
  const closeSheet = useCallback(() => setSheetOpen(false), []);

  const value = {
    xp,
    challengeDone,
    saved,
    liked,
    chips,
    theme,
    toast,
    sheetOpen,
    menuOpen,
    showToast,
    setChip: (group, next) => setChips((prev) => ({ ...prev, [group]: next })),
    toggleTheme: () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark')),
    openSheet,
    closeSheet,
    openMenu,
    closeMenu,
    markSaved: (key, message) => {
      setSaved((prev) => ({ ...prev, [key]: true }));
      if (message) showToast(message);
    },
    toggleLike: (key) => setLiked((prev) => ({ ...prev, [key]: !prev[key] })),
    startChallenge: () => {
      if (challengeDone) return;
      setChallengeDone(true);
      setXp((value) => value + 50);
      showToast('+50 XP earned');
    },
  };

  return <StudentContext.Provider value={value}>{children}</StudentContext.Provider>;
};

export const useStudent = () => {
  const context = useContext(StudentContext);
  if (!context) {
    throw new Error('useStudent must be used inside StudentLayout');
  }
  return context;
};
